module.exports = __webpack_public_path__ + "static/media/ltiaas.c0658fbb.gif";